import { ReactElement } from 'react';
import ChartCard from '../../../components/ChartCard';
import { MapContainer, Marker, Polyline, Popup, TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { DivIcon, LatLngExpression } from 'leaflet';

export default function RunMap(props: {
  lats: number[];
  lons: number[];
  gates_lat?: number[];
  gates_lon?: number[];
}): ReactElement {
  const { lats, lons, gates_lat, gates_lon } = props;
  const raw_lats: number[] = lats || [];
  const nonempty_lats = raw_lats.filter((i) => i);
  const raw_lons: number[] = lons || [];
  const nonempty_longs = raw_lons.filter((i) => i);
  const coordinates: LatLngExpression[] = nonempty_lats.map((lat: number, index: any) => {
    const long = nonempty_longs[index];
    return [lat, long];
  });

  const startMarkerIcon = new DivIcon({
    html: `
      <div style="position: relative; width: 100px; height: 100px;">
        <div style="position: absolute; left: 50%; bottom: 0; transform: translateX(-50%);">
          <div style="width: 8px; height: 8px; background-color: #BBD5DE; border-radius: 50%;
            border: 2px solid white;"></div>
        </div>
        <div style="position: absolute; left: 50%; bottom: 6px; transform: translateX(-50%);
          width: 2px; height: 30px; background-color: #BBD5DE; opacity: 0.6;"></div>
        <div style="position: absolute; left: 50%; bottom: 36px; transform: translateX(-50%);
          background-color: #BBD5DE; color: #03365D; padding: 4px 12px; font-weight: bold;
          font-size: 12px; border-radius: 4px; box-shadow: 0 2px 5px rgba(0,0,0,0.3);
          transform: translateX(-50%) rotate(-45deg); white-space: nowrap; opacity: 0.6;">
          Gate A
        </div>
      </div>
    `,
    className: '',
    iconSize: [100, 100],
    iconAnchor: [50, 94],
  });
  const endMarkerIcon = new DivIcon({
    html: `
      <div style="position: relative; width: 100px; height: 100px;">
        <div style="position: absolute; left: 50%; bottom: 0; transform: translateX(-50%);">
          <div style="width: 8px; height: 8px; background-color: #03365D; border-radius: 50%;
            border: 2px solid white;"></div>
        </div>
        <div style="position: absolute; left: 50%; bottom: 6px; transform: translateX(-50%);
          width: 2px; height: 30px; background-color: #03365D; opacity: 0.6;"></div>
        <div style="position: absolute; left: 50%; bottom: 36px; transform: translateX(-50%);
          background-color: #03365D; color: white; padding: 4px 12px; font-weight: bold;
          font-size: 12px; border-radius: 4px; box-shadow: 0 2px 5px rgba(0,0,0,0.3);
          transform: translateX(-50%) rotate(-45deg); white-space: nowrap; opacity: 0.6;">
          Gate B
        </div>
      </div>
    `,
    className: '',
    iconSize: [100, 100],
    iconAnchor: [50, 94],
  });
  if (coordinates.length === 0) {
    return <div>This run has no coordinates</div>;
  }

  const startGate: LatLngExpression = gates_lat && gates_lon ? [gates_lat[0], gates_lon[0]] : coordinates[0];
  const endGate: LatLngExpression =
    gates_lat && gates_lon ? [gates_lat[1], gates_lon[1]] : coordinates[coordinates.length - 1];

  // Calculate midpoint between gates A and B
  const mapCenter: LatLngExpression =
    gates_lat && gates_lon
      ? [(gates_lat[0] + gates_lat[1]) / 2, (gates_lon[0] + gates_lon[1]) / 2]
      : startGate;

  return (
    <ChartCard className="cr-h-96 cr-overflow-hidden">
      <MapContainer center={mapCenter} zoom={15} scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={startGate} icon={startMarkerIcon}>
          <Popup>Gate A</Popup>
        </Marker>
        <Marker position={endGate} icon={endMarkerIcon}>
          <Popup>Gate B</Popup>
        </Marker>
        <Polyline pathOptions={{ color: 'purple' }} positions={coordinates} />
      </MapContainer>
    </ChartCard>
  );
}
